import * as React from 'react';
import { Tag } from '../types';
const colClassPrefixes = {
    span: 'grid-span-',
    spanXs: 'grid-span-xs-',
    spanSm: 'grid-span-sm-',
    spanMd: 'grid-span-md-',
    spanLg: 'grid-span-lg-',
    offset: 'grid-offset-',
    offsetXs: 'grid-offset-xs-',
    offsetSm: 'grid-offset-sm-',
    offsetMd: 'grid-offset-md-',
    offsetLg: 'grid-offset-lg-',
};
const colSpanAndOffsetPropsKeys = Object.keys(colClassPrefixes);
export function mapGridColPropsToCssClasses({ props, postfix = '', additionalClasses = null, }) {
    let result = [`grid-col${postfix}`];
    for (let i = 0; i < colSpanAndOffsetPropsKeys.length; i++) {
        const propName = colSpanAndOffsetPropsKeys[i];
        if (propName in props) {
            result.push(colClassPrefixes[propName] + props[propName] + postfix);
        }
    }
    if (additionalClasses) {
        result = result.concat(additionalClasses);
    }
    return result.join(' ');
}
export const GridCol = (props) => {
    const { children, tag: Element = Tag.DIV } = props;
    const className = mapGridColPropsToCssClasses({ props });
    return React.createElement(Element, { className: className }, children);
};
//# sourceMappingURL=component.js.map